import { ReportState, ReportActions } from './../types/reportTypes';
import { WAS_REPORTED } from '../constants/index';

const initialState: ReportState = {
  id: 0,
  status: ''
}

const reportReducer = (state = initialState, action: ReportActions) => {
  const payload = action.payload
  switch(action.type){
    case WAS_REPORTED:
      return {
        ...state,
        id: payload.id,
        status: payload.status
      }
    
    default: 
      return state
  }
}

export default reportReducer;